var CurrentUser = require('lib/account/CurrentUser');

var Modal = require("components/utility/AltModal");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var LoadingButton = require("components/utility/LoadingButton");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

require('users/parents/parent_info_modal.scss');

class ParentInfoModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { loading: false };
	}

	show() {
		this.refs.modal.show();
	}

	handleInformationSubmit(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		var errors = [];

		if (!this.state.loading) {
			this.setState({ loading: true });
			var firstName = this.refs.first_name.value;
			var lastName = this.refs.last_name.value;

			if (firstName == "" || lastName == "") {
				errors.push("Please enter your first and last name.");
			}

			if (errors.length == 0) {
				var parentData = { first_name: firstName, last_name: lastName, not_accepted_terms: false }
				var title = "Name Saved!"
				var text = "Thank you for updating your name on Whooo's Reading."

				CurrentUser.api().patchParent(this.props.parentID, { parent: parentData }, $wr.apiHandler(function(response) {
					this.setState({ loading: false });
					this.refs.modal.hide();
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle" });
					if (this.props.onUpdateSuccess) {
						this.props.onUpdateSuccess();
					}
				}.bind(this)));
			} else {
				this.setState({ loading: false });
				this.refs.errors.setErrors(errors);
			}
		}
	}

	render() {
		var modalBody = (
			<div className="modalBody">
				<p>
					Welcome to Whooo's Reading! <br />
					Your name will appear when you sign off on your child's reading logs.
				</p>
				<ErrorDisplay ref="errors" />
				<form className="parentInfoForm" onSubmit={ this.handleInformationSubmit }>
					<div className="inputContainer">
						<p className="inputLabel">First Name</p>
						<input className="form-control" ref="first_name" />
					</div>
					<div className="inputContainer">
						<p className="inputLabel">Last Name</p>
						<input className="form-control" ref="last_name" />
					</div>

					<LoadingButton className="btn buttonSuccess center-block"
						loading={ this.state.loading } text="Submit" />

				    <p className="terms">
				    	By clicking this button, you are agreeing to our<span className="spacer0" />
				    	<a href={ WhooosReadingServices.OuterPages.url("/terms") }>
							Terms of Service
						</a> and<span className="spacer0" />
						<a href={ WhooosReadingServices.OuterPages.url("/privacy") }>
							Privacy Policy
						</a>.
					</p>
				</form>
			</div>
		)

		return (
			<Modal className="parentInfoModal" ref="modal" modalOrder={ 2 }
				headerText="Parent Information" selfOpen>
				{ modalBody }
			</Modal>
		)
	}

}

ParentInfoModal.propTypes = StrictPropTypes({
	parentID: PropTypes.string.isRequired,
	onUpdateSuccess: PropTypes.func,
	parentToken: PropTypes.string
});


module.exports = ParentInfoModal;


// WEBPACK FOOTER //
// ./modules/components/users/parents/ParentInfoModal.js